import React from 'react';
import PropTypes from 'prop-types';
import { QuoteProductDto } from '../quotes/otherQuoteEntities';
import tineDiagramsService from '../tine-diagrams/tineDiagramsService';
import { PageLoadingSpinner } from '@ami/react/core';
import TineDiagramInput from '../tine-diagrams/tineDiagramInput';
//import './ProductTineConfiguration.scss';
import QuoteProductDetail from '../quotes/entities/quoteProductDetail';

export default class ProductTineConfiguration extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      tineDiagram: null,
    };
  }

  static propTypes = {
    weightCategoryId: PropTypes.string.isRequired,
    thumbBucketProfileId: PropTypes.string.isRequired,
    couplerStyleId: PropTypes.string,
    productThumb: PropTypes.instanceOf(QuoteProductDto).isRequired,
    productBucket: PropTypes.instanceOf(QuoteProductDto),
    onUpdate: PropTypes.func.isRequired,
    entity: PropTypes.instanceOf(QuoteProductDetail).isRequired,
  };

  async componentDidMount() {
    await this.loadEntity();
  }

  async componentDidUpdate(prevProps) {
    if (
      prevProps.productThumb &&
      this.props.productThumb &&
      prevProps.productThumb.productId !== this.props.productThumb.productId
    ) {
      this.setState({ tineDiagram: null });
      await this.loadEntity();
    }
  }

  loadEntity = async () => {
    const {
      productThumb,
      productBucket,
      weightCategoryId,
      thumbBucketProfileId,
      couplerStyleId,
      onUpdate,
      entity,
    } = this.props;
    const tineDiagram = await tineDiagramsService.get(
      new TineDiagramInput({
        productThumb,
        productBucket,
        weightCategoryId,
        thumbBucketProfileId,
        couplerStyleId,
      })
    );
    entity.tineDiagram = tineDiagram.tineDiagram;
    entity.tipRadiusDiagram = tineDiagram.tipRadiusDiagram;
    entity.thumbTipRadius = tineDiagram.thumbTipRadius;
    onUpdate(entity);
    this.setState({ tineDiagram });
  };

  render() {
    const { tineDiagram } = this.state;

    if (!tineDiagram) {
      return <PageLoadingSpinner />;
    }

    return (
      <div>
        <div className="row">
          <div className="col-6">
            <div className="text-center">
              Based on the bucket & coupler information{' '}
            </div>
            <div className="text-center">
              provided, we have determined your thumb
            </div>
            <div className="text-center">
              will require a tip radius of{' '}
              <span className="yellow-count">
                {tineDiagram.thumbTipRadius}"
              </span>
            </div>
          </div>
          <div className="col-6">
            <div className="text-center">
              Please review the below image which illustrates how{' '}
            </div>
            <div className="text-center">
              the thumb tines will interact with the bucket.
            </div>
            <div className="text-center">
              If you have any questions, please contact AMI.
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <img
              className="img-thumbnail"
              id="tipRadiusSideViewBase64Image"
              alt="AMI"
              src={`data:image/png;base64,${tineDiagram.tipRadiusSideViewBase64Image}`}
            />
          </div>
          <div className="col-6">
            <img
              className="img-thumbnail"
              id="thumbBodyBase64Image"
              alt="AMI"
              src={`data:image/png;base64,${tineDiagram.thumbBodyBase64Image}`}
            />
          </div>
        </div>
      </div>
    );
  }
}
